module.exports = __webpack_public_path__ + "7a7e881e5fb0397231519043d124b9c2.png";